import {
  forwardRef,
  memo,
  useCallback,
  useEffect,
  useImperativeHandle,
  useMemo,
  useState,
} from "react";
import { Grid, Typography } from "@mui/material";
import ItemsList from "../../../components/ItemsList/ItemsList";
import { formatTaskRows } from "../Board";
import ReloadIcon from "../../../components/ReloadIcon/ReloadIcon";
import { getTasks } from "../../../request/task";
import { useUserStore } from "../../../store/user";
import MembersList from "../components/MembersList/MembersList";
function TaskList(
  {
    title,
    filter = {},
    sort = "-asana_created_at",
    tasksHeaders,
    checkMembers = false,
    reloadList = true,
  },
  ref,
) {
  useImperativeHandle(ref, () => ({
    reload: () => {
      reload();
    },
  }));

  const [elements, setElements] = useState(null);
  const [total, setTotal] = useState(null);
  const [loadFilter, setLoadFilter] = useState(null);
  const [showReloadIcon, setShowReloadIcon] = useState(false);

  const [loadParams, setLoadParams] = useState({
    page: { size: 10, number: 1 },
  });

  const { selectedAssignees } = useUserStore();
  useEffect(() => {
    if (checkMembers && selectedAssignees != null) {
      setLoadFilter({
        ...loadFilter,
        ...filter,
        assignee_id: selectedAssignees.join(","),
      });
    }
  }, [selectedAssignees]);

  const formatItems = useCallback(() => {
    if (!elements) return;
    return formatTaskRows(elements);
  }, [elements]);

  const getFilter = useMemo(() => {
    return loadFilter ?? filter;
  }, [loadFilter]);
  const getData = async () => {
    try {
      const response = await getTasks(
        loadParams?.sort ?? sort,
        getFilter,
        loadParams?.page,
        ["sla"],
      ).catch((err) => {});

      setElements(response?.data?.data);
      setTotal(response?.data?.meta?.total);

      if (reloadList) {
        setShowReloadIcon(true);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const pageReload = async (params) => {
    if (params) {
      setLoadParams(params);
    }
  };

  const reload = async () => {
    setShowReloadIcon(false);
    setTimeout(async () => {
      await getData();
    }, 500);
  };

  useEffect(() => {
    if (checkMembers && !loadFilter) {
      return;
    }
    const get = async () => {
      await reload();
    };
    get().catch((err) => console.error(err));

    let intervalCall = null;
    if (reloadList) {
      intervalCall = setInterval(async () => {
        await reload();
      }, 59000);
    }
    return () => {
      // clean up
      if (intervalCall) {
        clearInterval(intervalCall);
      }
    };
  }, [loadParams, loadFilter]);

  const getGridId = useMemo(() => {
    let str = title.replace(" ", "").toLowerCase();
    return str + "-id";
  }, [title]);

  return (
    <div className="block-inner">
      <Grid container spacing="15px">
        <Grid item xs={12} md={3}>
          <div className="tasks-table-title flex-start mb-15">
            <div>
              <Typography variant="h6">{title}</Typography>
            </div>
            <div className="pl-15">
              {!!showReloadIcon && (
                <div
                  className="reload-btn"
                  title="Reload"
                  onClick={() => {
                    reload();
                  }}
                >
                  {" "}
                  <ReloadIcon timeout={60} />
                </div>
              )}
            </div>
          </div>
        </Grid>
        <Grid item xs={12} md={9}>
          {!!checkMembers && <MembersList />}
        </Grid>
      </Grid>

      {elements && (
        <ItemsList
          items={formatItems()}
          headers={tasksHeaders}
          totalCount={total}
          defaultPageSize={loadParams?.page?.size}
          server={true}
          getItems={pageReload}
          gridId={getGridId}
        />
      )}
    </div>
  );
}

export default memo(forwardRef(TaskList));
